/* eslint-disable max-len */
export default {
  // Login
  sendMessage: 'Message Sending',
  adminId: 'Admin ID',
  adminPw: 'Admin Password',
  loginBtn: 'Login',
  title: 'Server Admin Verification',
  validationLoginIdNull: 'Please enter your ID.',
  validationLoginPasswordNull: 'Please enter your password.',
  authFail: 'Invalid ID or password.',
  mfaAuthFail: 'The verification code does not match.',
  sendMfAuthCode: 'Verification code has been sent.',
  certificationMethod: 'Verification Method',
  smsCertification: 'SMS Verification',
  emailCertification: 'E-mail Verification',
  certificationTel: 'Admin Number',
  certificationEmail: 'Admin Email',
  certificationCodeBtn: 'Send Verification Code',
  certificationCode: 'Verification Code',
  certificationPlaceholder: 'Please enter the verification code.',
  chooseRegistered: 'Please select a registered item.',
  unpredictableFail: 'Login failed.\nPlease contact the administrator.',
  captionContent: `Please select a verification method and an admin number (or admin email), then click the "Send Code" button.
    After receiving the code, enter it in the input field and click "Confirm"`,
};
